const DeviationPriceUnitEnum = {
  PPO: { id: 1, code: "PPO" }, //pay per order
  PM: { id: 2, code: "PM" }, //pay per meter
  PS: { id: 3, code: "PS" }, //pay per stk
  PH: { id: 4, code: "PH" }, //pay per hour
  PK: { id: 5, code: "PK" }, //pay per kilo
  PT: { id: 6, code: "PT" }, //pay per tonn
} as const;

export default DeviationPriceUnitEnum;
